import { Footer } from '@/components/layout/Footer';
import { Header } from '@/components/layout/Header';
import { rootRoute } from '@/routes/rootRoute';
import { routes } from '@/routes/routes';
import { Outlet, createRoute } from '@tanstack/react-router';
import { IngredientPage } from './ingredients/IngredientPage';
import { IngredientsPage } from './ingredients/IngredientsPage';
import { PrivacyPolicyPage } from './legal/PrivacyPolicyPage';
import { ReturnsAndRefundsPage } from './legal/ReturnsAndRefundsPage';
import { ShippingPage } from './legal/ShippingPage';
import { TermsAndConditionsPage } from './legal/TermsAndConditionsPage';
import { ProtocolsPage } from './protocols/ProtocolsPage';

export const PublicLayout = () => {
  return (
    <div>
      <div className="flex min-h-screen flex-col">
        <Header />

        <Outlet />
      </div>

      <Footer />
    </div>
  );
};

export const publicLayoutRoute = createRoute({
  id: '_public-layout',
  getParentRoute: () => rootRoute,
  component: PublicLayout,
});

export const privacyPolicyRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.legal.privacyPolicy,
  component: PrivacyPolicyPage,
});

export const returnsAndRefundsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.legal.returnsAndRefunds,
  component: ReturnsAndRefundsPage,
});

export const shippingRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.legal.shipping,
  component: ShippingPage,
});

export const termsAndConditionsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.legal.termsAndConditions,
  component: TermsAndConditionsPage,
});

export const ingredientsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.ingredients.index,
  component: IngredientsPage,
});

export const ingredientRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.ingredients.ingredient,
  params: {
    parse: (params) => ({
      ingredientId: Number(params.ingredientId),
    }),
  },
  component: IngredientPage,
});

export const protocolsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: routes.protocols,
  component: ProtocolsPage,
});

export const publicRoutes = publicLayoutRoute.addChildren([
  privacyPolicyRoute,
  returnsAndRefundsRoute,
  shippingRoute,
  termsAndConditionsRoute,
  ingredientsRoute,
  ingredientRoute,
  protocolsRoute,
]);
